import { Component, Input } from '@angular/core';

@Component({
  selector: 'bepatient-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: false
})
export class EmptyStateComponent {
  @Input() color: string;
  @Input() title: string;
  @Input() content: string;
}
